import React, { useEffect, useState } from "react";
import up_arrow from "../assets/images/icons/new/up_arrow.png";

const ScrollBottomToTopComponent = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible(window.scrollY > 300);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    isVisible && (
      <div className="fixed right-[10px] hidden md:fixed bottom-[15px] z-50 ">
        <div
          onClick={scrollToTop}
          className="cursor-pointer flex items-center justify-center bg-[#0d4745] border-4 border-[#FDFBE6] rounded-full w-[80px] h-[80px] absolute right-[50px] bottom-[50px]"
        >
          <img className="w-8" src={up_arrow} alt="arrow" />
        </div>
      </div>
    )
  );
};

export default ScrollBottomToTopComponent;
